/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AdminSlideListSpecimen = {
    readonly id?: number;
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    biopsy_type?: AdminSlideListSpecimen.biopsy_type;
    procedure?: AdminSlideListSpecimen.procedure | null;
    /**
     * Changing this value will ALSO modify the received_date for the case.
     */
    received_date?: string | null;
}

export namespace AdminSlideListSpecimen {

    export enum biopsy_type {
        PUNCH = 'PUNCH',
        SHAVE = 'SHAVE',
        EXCISION = 'EXCISION',
        UNKNOWN = 'UNKNOWN',
    }

    export enum procedure {
        C = 'c',
        E = 'e',
        PE = 'pe',
        IB = 'ib',
        NC = 'nc',
        NA = 'na',
        PB = 'pb',
        SB = 'sb',
        SBD = 'sbd',
        SR = 'sr',
        SRD = 'srd',
        SNB = 'snb',
        GR = 'gr',
        SE = 'se',
        EBX = 'ebx',
        FB = 'fb',
        MOHS = 'mohs',
        DBLK = 'dblk',
        U = 'u',
        O = 'o',
    }


}
